import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';

// import { HeroExtraBlock } from 'apps/promo/components/acceptInvite/HeroExtraBlock';
import ColoredSectionContainer from 'apps/promo/components/common/ColoredSectionContainer';
import { PromoPageContainer } from 'apps/promo/components/common/promo-page-container/PromoPageContainer';
import FaqSection from 'apps/promo/components/common/sections/FaqSection';
import HeadingSection from 'apps/promo/components/common/sections/HeadingSection';
import { HeroSection } from 'apps/promo/components/common/sections/HeroSection';
import { TilesSection } from 'apps/promo/components/common/sections/TilesSection';
import TrustpilotSection from 'apps/promo/components/common/sections/TrustpilotSection';
import { TileColoredWithChild } from 'apps/promo/components/common/tile-colored-with-child/TileColoredWithChild';
import PromoInputPartnerCode from 'apps/promo/components/form/PromoInputPartnerCode';
import PromoInputPhoneWithDropdown from 'apps/promo/components/form/PromoInputPhoneWithDropdown/PromoInputPhoneWithDropdown';
import NotAuthBasePage from 'apps/promo/components/NotAuthBasePage';
import PromoPopup from 'apps/promo/components/popup/PromoPopup';
import { NO_AUTH_LOGIN_REGISTRATION_FORM_NAME } from 'apps/promo/constants/formName';
import { useForm } from 'apps/promo/hooks/selectors';

import styles from './ReferralPages.module.css';
import { referralClickHandler } from './ReferralUtils';

const JetBluePage = (props) => {
    const popupRef = useRef(null);
    const form = useForm(NO_AUTH_LOGIN_REGISTRATION_FORM_NAME);
    const alreadyRegisteredRef = useRef(null);

    // this page is only for US
    const currentCountry = 'US';

    const partnerCode = form?.fields?.partner_code?.value;
    const isPartnerCodeNumeric = partnerCode !== '' && !isNaN(Number(partnerCode));

    const isBtnDisabled = !(
        form?.fields?.phone_number?.value &&
        (form?.fields?.phone_prefix?.value + form?.fields?.phone_number?.value).length >= 6 &&
        partnerCode.length >= 10 &&
        isPartnerCodeNumeric
    );

    useEffect(() => {
        const hash = window.location.hash;
        if (hash) {
            const el = document.querySelector(hash);
            if (el) {
                setTimeout(() => {
                    el.scrollIntoView({ behavior: 'smooth' });
                }, 0);
            }
        }
    }, []);

    const scrollToTile = () => {
        alreadyRegisteredRef.current?.scrollIntoView({
            behavior: 'smooth',
        });
    };

    return (
        <>
            <PromoPageContainer bgColor="eggshell03" noIndent>
                {props.heroTitle && (
                    <HeroSection
                        title={props.heroTitle}
                        text={props.heroText}
                        heroNote={props.heroNote}
                        img={props.heroImg}
                        data={props.heroData}
                        note={props.extraBlockNote}
                        headerHidden={props.headerHidden}
                        horizontalLayout
                        // hasQrCode
                        fullwidth
                        compactExtraBlock
                        hasLogo
                        // extraComponent={
                        //     <HeroExtraBlock
                        //         extraBlockTitle={props.extraBlockTitle}
                        //         currentCountry={currentCountry.toLowerCase()}
                        //         countries={props.availableCountries}
                        //         labelText={props.inputLabel}
                        //         btnTitle={props.heroData?.extra_button?.title}
                        //         isMobileDevice={props.isMobileDevice}
                        //         disabledBtn={isBtnDisabled}
                        //         onExtraButtonClick={() =>
                        //             referralClickHandler(
                        //                 form,
                        //                 popupRef,
                        //                 'JetBlue',
                        //                 props.lang,
                        //                 props.isMobileDevice,
                        //                 'jet-blue-page',
                        //                 true,
                        //                 props.popupErrorText,
                        //             )
                        //         }
                        //         searchPlaceholder={props.searchPlaceholder}
                        //         searchFullPlaceholder={props.searchFullPlaceholder}
                        //         searchModalTitle={props.searchModalTitle}
                        //         searchNoResult={props.searchNoResult}
                        //         isNonEditableCountry
                        //         partnerCodeInputTitle={props.partnerCodeInputTitle}
                        //         partnerCodeInputHint={props.partnerCodeInputHint}
                        //         btnSecondaryTitle={props.heroData?.extra_secondary_button?.title}
                        //         onExtraSecondaryButtonClick={scrollToTile}
                        //     />
                        // }
                    />
                )}
                <ColoredSectionContainer>
                    {props.headline1Title && <HeadingSection title={props.headline1Title} text={props.headline1Text} />}
                    {props.lang && <TrustpilotSection lang={props.lang} />}
                    {props.headline2Title && <HeadingSection title={props.headline2Title} text={props.headline2Text} />}
                    {props.tiles && <TilesSection data={props.tiles} lang={props.lang} country={props.country} loadingLazy grayText />}
                </ColoredSectionContainer>

                {props.faqTitle && props.questions && <FaqSection title={props.faqTitle} questions={props.questions} noTopPadding bgColor={'transparent'} />}

                {props.getStartedTile && (
                    <ColoredSectionContainer noTopPadding bottomPadding>
                        <TileColoredWithChild
                            title={props.getStartedTile.title}
                            subtitle={props.getStartedTile.subtitle}
                            titleGradient={props.getStartedTile.color?.titleGradient}
                            bgColor={props.getStartedTile.color?.bgColor}
                            btnTitle={props.getStartedTile.btn_title}
                            disabledBtn={isBtnDisabled}
                            note={props.getStartedTile.note}
                            onButtonClick={() =>
                                referralClickHandler(form, popupRef, 'JetBlue', props.lang, props.isMobileDevice, 'jet-blue-page', true, props.popupErrorText)
                            }
                            btnSecondaryTitle={props.alreadyInPaysendButtonTitle}
                            onButtonSecondaryClick={scrollToTile}
                        >
                            <div className={styles.inputWrapper}>
                                <PromoInputPhoneWithDropdown
                                    hasWhiteBg
                                    countries={props.availableCountries}
                                    currentCountry={currentCountry.toLowerCase()}
                                    labelText={props.inputLabel}
                                    searchPlaceholder={props.searchPlaceholder}
                                    searchFullPlaceholder={props.searchFullPlaceholder}
                                    searchModalTitle={props.searchModalTitle}
                                    searchNoResult={props.searchNoResult}
                                    isNonEditableCountry
                                />
                            </div>
                            <div className={styles.partnerCodeInputWrapper}>
                                <PromoInputPartnerCode
                                    labelText={props.partnerCodeInputTitle}
                                    hintText={props.partnerCodeInputHint}
                                    name={'partner_code_tile'}
                                    commentWhite
                                    commentCenter
                                />
                            </div>
                        </TileColoredWithChild>
                    </ColoredSectionContainer>
                )}

                {props.alreadyRegisteredTitle && props.alreadyRegistered && (
                    <div ref={alreadyRegisteredRef} id={'already-registered'}>
                        <FaqSection title={props.alreadyRegisteredTitle} questions={props.alreadyRegistered} isFirstOpened noTopPadding />
                    </div>
                )}
            </PromoPageContainer>
            <PromoPopup ref={popupRef} />
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        heroTitle: state.extra?.strapiApi?.hero_block?.title,
        heroText: state.extra?.strapiApi?.hero_block?.text,
        heroNote: state.extra?.strapiApi?.hero_block?.hero_note,
        heroData: state.extra?.strapiApi?.hero_block,
        heroBgImg: state.extra?.strapiApi?.hero_block?.bgImg,
        heroImg: state.extra?.strapiApi?.hero_block?.img,
        extraBlockNote: state.extra?.strapiApi?.hero_block?.note,
        extraBlockTitle: state.extra?.strapiApi?.hero_block?.extra_block_title,

        inputLabel: state.extra?.strapiApi?.input_label,

        headline1Title: state.extra?.strapiApi?.headline1?.title,
        headline1Text: state.extra?.strapiApi?.headline1?.text,

        headline2Title: state.extra?.strapiApi?.headline2?.title,
        headline2Text: state.extra?.strapiApi?.headline2?.text,

        tiles: state.extra?.strapiApi?.tiles_section,

        faqTitle: state.extra?.strapiApi?.faq?.title,
        questions: state.extra?.strapiApi?.faq?.questions,

        alreadyRegisteredTitle: state.extra?.strapiApi?.faq_already_registered?.title,
        alreadyRegistered: state.extra?.strapiApi?.faq_already_registered?.questions,

        getStartedTile: state.extra?.strapiApi?.get_started_tile,

        isMobileDevice: state.extra?.isMobile,

        availableCountries: state.extra?.strapiApi?.availableCountries,

        searchPlaceholder: state.extra?.strapiApi?.search_placeholder,
        searchFullPlaceholder: state.extra?.strapiApi?.search_full_placeholder,
        searchModalTitle: state.extra?.strapiApi?.search_modal_title,
        searchNoResult: state.extra?.strapiApi?.search_no_result,
        alreadyInPaysendButtonTitle: state.extra?.strapiApi?.already_in_paysend_button_title,

        lang: state.extra.noAuthFooter?.language?.lang,
        country: state.extra.noAuthFooter?.language?.country,

        popupErrorText: state.extra?.strapiApi?.phone_number_error,

        partnerCodeInputTitle: state.extra?.strapiApi?.partner_code_input_title,
        partnerCodeInputHint: state.extra?.strapiApi?.partner_code_input_hint,
    };
};

export default connect(mapStateToProps)(NotAuthBasePage(JetBluePage));
